// @vendors
const moment = require('moment');

// @utilities
const {
    recordProcess,
    PROC_END,
    PROC_FAIL,
    PROC_RA_CONTRACTS,
} = require('utilities/tagging');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
    FIFTH_STEP,
} = require('constants/index');

const {
    RA_INVESTMENT_TYPE_FOUNDS,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
} = require('../raConstants/index');
const {
    es: { DATE_FORMAT_WITH_SLASHES },
} = require('commonsConstants/dateFormatTypes');
const actionTypes = require('../raConstants/actionTypes');
const { getFormattedLanguage } = require('../utilities/RALanguageHelper');
const {
    ROBO_PRECONTRACT,
    ROBO_SHOW_IMPLICIT_COSTS,
    EVIDENCE_WEALTH_ROBO_HIRING,
} = require('constants/flagBasedFeatures');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const raErrorHandlerActions = require('./RAErrorHandler');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');

// @ commons
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const PersonalDataHelper = require('utilities/personalDataHelper');

const changeTransferFundsAccount = value => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_CHANGE_TRANSFER_FUNDS_ACCOUNT,
    payload: value,
});

const changeInvestmentType = value => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_CHANGE_INVESTMENT_TYPE,
    payload: value,
});

const configureUserEmail = data => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_CONFIGURE_EMAIL,
    payload: data,
});

const createAccountSuccess = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_FINISH,
});

const createAccountError = (error, step) => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_CREATE_ACCOUNT_ERROR,
    payload: {
        error,
        step,
    },
});

const updateSelectedAccountsWithFunds = (
    accountId,
    newSelectedAccountsWithFunds,
) => ({
    type:
        actionTypes.RA_HIRE_MANAGEMENT_PLAN_UPDATE_SELECTED_ACCOUNTS_WITH_FUNDS,
    payload: {
        accountId,
        newSelectedAccountsWithFunds,
    },
});

const updateSelectedFundsTotal = newAmount => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_UPDATE_SELECTED_FUNDS_TOTAL,
    payload: {
        newAmount,
    },
});

const requestCreateAccount = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_CREATE_ACCOUNT_REQUEST,
});

const reset = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_RESET,
});

const resetStep = step => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_RESET_STEP,
    payload: {
        step,
    },
});

const setNextStep = step => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_VISIBLE_STEP,
    payload: {
        step,
    },
});

const saveTermsAndConditions = termsAndConditions => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SAVE_TERMS_AND_CONDITIONS,
    payload: termsAndConditions,
});

const setVisibleStep = (step, nextButton) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const currentVisibleStep = getState().raHireManagementPlan.get(
        'visibleStep',
    );
    let stepNumber = step;
    if (
        PersonalDataHelper.getEmail(immProfile) &&
        currentVisibleStep != step &&
        step === 3
    ) {
        stepNumber = nextButton ? step + 1 : step - 1;
    }
    dispatch(setNextStep(stepNumber));
};

const setInvestmentAmount = value => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_INVESTMENT_AMOUNT_CHANGED,
    payload: {
        value,
    },
});

const setSelectedAccount = (accountId, accountBalance, originCountry = '') => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SELECTED_ACCOUNT_CHANGED,
    payload: {
        accountId,
        accountBalance,
        originCountry,
    },
});

const validateUIStep = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_VALIDATE_UI_STEP,
});

const toggleDisclaimer = () => dispatch => {
    dispatch({
        type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_TOGGLE_DISCLAIMER,
    });
    dispatch(validateUIStep());
};

const validateCalendarStep = () => dispatch => {
    dispatch(validateUIStep());
};

const setInitialContributionAmount = amount => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT,
    payload: {
        amount,
    },
});

const setRecurringContributionAmount = amount => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT,
    payload: {
        amount,
    },
});

const setPeriodicity = periodicity => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_PERIODICITY,
    payload: {
        periodicity,
    },
});

const setContributionDay = contributionDay => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_CONTRIBUTIONDAY,
    payload: {
        contributionDay,
    },
});

const b64toBlob = (b64Data, typeContent) => {
    const byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512),
            byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: typeContent });
    return blob;
};

const setPDF = (pdf, pdfContent) => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_PDF,
    payload: {
        pdf,
        pdfContent,
    },
});

const setConcatPDF = (pdfConcat, pdfConcatURL = null) => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_CONCAT_PDF,
    payload: {
        pdfConcat,
        pdfConcatURL,
    },
});

const getPDFContract = (
    history,
    inlinePdf = true,
    implicitCostsFromResponse = null,
) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immGlobalVariables = getState().globalVariables;
    const flagBasedFeatures = getState().flagBasedFeatures;
    const hasPrecontract = flagBasedFeatures.get(ROBO_PRECONTRACT);
    const showImplicitCost = flagBasedFeatures.get(ROBO_SHOW_IMPLICIT_COSTS);
    const immHireManagementPlan = getState().raHireManagementPlan;
    const implicitCosts = showImplicitCost
        ? !!implicitCostsFromResponse
            ? implicitCostsFromResponse
            : immHireManagementPlan.get('productCost')
        : null;

    const query = {
        ccAccount: '', // @hardcoded
        email: '', // @hardcoded
        gdcAccount: '', // @hardcoded
        idNumber: immProfile.getIn([
            'documentoIdentificacion',
            'codigodocumpersonacorp',
        ]),
        name: immProfile.get('fullname'),
        signFlag: 'PRE', // @hardcoded
        timestamp: moment().format(DATE_FORMAT_WITH_SLASHES),
        ...(implicitCosts && { implicitCosts }),
    };

    APIPost(dispatch, apiURLBuilder.getURL('raPDFContract'), { query })
        .then(response => {
            if (inlinePdf) {
                const base64url = URL.createObjectURL(
                    b64toBlob(response.generatedPdf, 'application/pdf'),
                ); // safari browser needs a proper MIME type here to show pdfs
                const base64String = `data:application/pdf;base64,${response.generatedPdf}`;
                dispatch(setPDF(base64String, base64url));
            } else {
                dispatch(setPDF(response.generatedPdf));
            }
        })
        .catch(() => {
            dispatch(errorActions.show('', history));
        });

    if (hasPrecontract) {
        const precontractualURLValue = immGlobalVariables.getIn([
            'variables',
            'parameters',
            'contratos',
            'precontractuales_robo',
        ]);
        query.preContractualUrl = precontractualURLValue;
        APIPost(dispatch, apiURLBuilder.getURL('raPDFContract'), { query })
            .then(response => {
                if (inlinePdf) {
                    const base64String = `data:application/pdf;base64,${response.generatedPdf}`;
                    const base64url = URL.createObjectURL(
                        b64toBlob(response.generatedPdf, 'application/pdf'),
                    ); // safari browser needs a proper MIME type here to show pdfs
                    dispatch(setConcatPDF(base64String, base64url));
                } else {
                    dispatch(setConcatPDF(response.generatedPdf));
                }
            })
            .catch(() => {
                dispatch(errorActions.show('', history));
            });
    }
};

const getEvidencePdf = (
    history,
    processType,
    operationProcessId,
    implicitCosts,
) => dispatch => {
    const params = {
        processType,
        operationProcessId,
    };
    return APIGet(dispatch, apiURLBuilder.getURL('raPDFEvidence', params))
        .then(response => {
            const base64url = URL.createObjectURL(
                b64toBlob(response.base64Document, 'application/pdf'),
            );
            const base64String = `data:application/pdf;base64,${response.base64Document}`;
            dispatch(setPDF(base64String, base64url));
        })
        .catch(() => {
            dispatch(getPDFContract(history, true, implicitCosts));
        });
};

const dmsManagementPlanInitFetching = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_FETCHING,
});

const dmsManagementPlanInitSuccess = response => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_SUCCESS,
    payload: { operationProcessId: response.operationProcessId },
});

const dmsManagementPlanInitError = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_ERROR,
});

const dmsManagementPlanInit = (history, implicitCosts = null) => dispatch => {
    const requestData = {
        query: {
            implicitCosts,
            wealthOperationProcessType:
                'WEALTH_DISCRETIONARY_MANAGEMENT_CONTRACT',
        },
    };

    dispatch(dmsManagementPlanInitFetching());

    return APIPost(dispatch, apiURLBuilder.getURL('raDMSInit'), requestData)
        .then(response => {
            dispatch(dmsManagementPlanInitSuccess(response));
        })
        .catch(() => {
            dispatch(dmsManagementPlanInitError());
            dispatch(getPDFContract(history, true, implicitCosts));
        });
};

const validateStep = (step, history) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immHireManagementPlan = getState().raHireManagementPlan;
    const implicitCosts = immHireManagementPlan.get('productCost');
    const operationProcessId = immHireManagementPlan.get('operationProcessId');
    if (step === 2) {
        dispatch(
            getEvidencePdf(
                history,
                'WEALTH_DISCRETIONARY_MANAGEMENT_CONTRACT',
                operationProcessId,
                implicitCosts,
            ),
        );
    }
    if (
        step === 0 &&
        immFlagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING) &&
        !__CONTACT_CENTER__
    ) {
        dispatch(dmsManagementPlanInit(history, implicitCosts));
    }
    if (__CONTACT_CENTER__ && step === FIFTH_STEP) {
        dispatch(validateUIStep());
    } else {
        dispatch(setVisibleStep(step + 1, true));
    }
};

const emailConfigurationError = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_EMAIL_CONFIG_ERROR,
});

const restValueOfPortfolio = () => ({
    type: actionTypes.RA_SAVE_SIMULATION_RESET,
});

const restValueOfObjective = () => ({
    type: actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET,
});

const deleteSimulation = (simulationId, successHire = false) => (
    dispatch,
    getState,
) => {
    const saveSimulationPortfolioId = getState().raSaveSimulation.getIn([
        'saveSimulationPortfolio',
        'simulationId',
    ]);
    const saveSimulationObjectiveId = getState().raSaveSimulation.getIn([
        'saveSimulationObjective',
        'simulationId',
    ]);
    if (
        saveSimulationPortfolioId &&
        simulationId == saveSimulationPortfolioId
    ) {
        dispatch(restValueOfPortfolio());
    }
    if (
        saveSimulationObjectiveId &&
        simulationId == saveSimulationObjectiveId &&
        !successHire
    ) {
        dispatch(restValueOfObjective());
    }
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raDeleteSimulation', { simulationId }),
        {},
    );
};

const getChannel = () => {
    if (__CONTACT_CENTER__) {
        return isPrintOfficeMode() ? 'OFI' : 'CC';
    }
    return 'WEB';
};

const createAccount = (dataToken, includeObjective, history) => (
    dispatch,
    getState,
) => {
    const immAccounts = getState().accounts;
    const immProfile = getState().profile;
    const immHireManagementPlan = getState().raHireManagementPlan;
    const immGlobalVariables = getState().globalVariables;
    const flagBasedFeatures = getState().flagBasedFeatures;
    const hasPrecontract = flagBasedFeatures.get(ROBO_PRECONTRACT);
    const showImplicitCost = flagBasedFeatures.get(ROBO_SHOW_IMPLICIT_COSTS);
    const immSimulation = getState().raSimulation.get('simulation');
    const immTimeHorizonCheck = getState().raTimeHorizonCheck;
    const isHiringWithFunds =
        immHireManagementPlan.getIn(['steps', FIRST_STEP, 'investmentType']) ===
        RA_INVESTMENT_TYPE_FOUNDS;
    const includeRecurringTransfer = !!parseFloat(
        immHireManagementPlan.getIn([
            'steps',
            SECOND_STEP,
            'recurringContributionAmount',
        ]),
    );
    const implicitCosts = immHireManagementPlan.get('productCost');
    const accountId = immHireManagementPlan.getIn([
        'steps',
        THIRD_STEP,
        'selectedAccount',
    ]);
    const currency = immAccounts.getIn([
        'byId',
        accountId,
        'balance',
        'currency',
    ]);
    const investmentAmount = isHiringWithFunds
        ? 0
        : immHireManagementPlan.getIn([
              'steps',
              FIRST_STEP,
              'investmentAmount',
          ]);
    const step = immHireManagementPlan.get('visibleStep');

    const numberContract = immAccounts.getIn([
        'byId',
        accountId,
        'contractNumber',
    ]);
    const product = immAccounts.getIn(['byId', accountId, 'product']);

    const to = includeObjective ? immSimulation.get('endDate') : undefined;
    const simulationId = immSimulation.get('id');
    const maxTypeOfProduct = includeObjective
        ? immTimeHorizonCheck.get('maxTypeOfProduct')
        : null;
    const emailConfigured = PersonalDataHelper.getEmail(immProfile);
    const emailData = !!emailConfigured
        ? emailConfigured
        : immHireManagementPlan.getIn(['steps', FOURTH_STEP, 'email']);
    const termsAndConditions = immHireManagementPlan.get('termsAndConditions');
    const preContractualUrl = hasPrecontract
        ? immGlobalVariables.getIn([
              'variables',
              'parameters',
              'contratos',
              'precontractuales_robo',
          ])
        : '';
    const paramsForDms = {
        operationProcessId: immHireManagementPlan.get('operationProcessId'),
        evidenceType: 'SIGN_DOCUMENT',
        termsAndConds: {
            acceptedText: termsAndConditions,
        },
    };
    const query = {
        contract: {
            numberContract,
            product,
        },
        channel: getChannel(),
        currency,
        dataToken: dataToken,
        email: emailData,
        goal: includeObjective
            ? {
                  amount: immSimulation.get('amount'),
                  currency: immSimulation.get('currency'),
                  cutDate: immSimulation.get('endDate'),
                  goalType: immSimulation.get('type').toUpperCase(),
                  maxTypeOfProduct,
                  name: immSimulation.get('name'),
              }
            : null,
        displayName: includeObjective
            ? immSimulation.get('name')
            : immSimulation.get('displayName'),
        initialTransfer: {
            amount: investmentAmount,
            currency,
            originAccount: {
                numberContract,
                product,
            },
        },
        name: immProfile.getIn(['fullname']),
        preContractualUrl: preContractualUrl,
        recurringTransfer: includeRecurringTransfer
            ? {
                  amount: immHireManagementPlan.getIn([
                      'steps',
                      SECOND_STEP,
                      'recurringContributionAmount',
                  ]),
                  currency,
                  cutDay: immHireManagementPlan.getIn([
                      'steps',
                      SECOND_STEP,
                      'contributionDay',
                  ]),
                  originAccount: {
                      numberContract: immAccounts.getIn([
                          'byId',
                          accountId,
                          'newContractNumber',
                      ]),
                      product: immAccounts.getIn([
                          'byId',
                          accountId,
                          'newProduct',
                      ]),
                  },
                  recurringCode: immHireManagementPlan.getIn([
                      'steps',
                      SECOND_STEP,
                      'periodicity',
                  ]),
                  to,
              }
            : null,
        selectedPortfolio: immSimulation.get('selectedPortfolio'),
        simulationId: simulationId || 0,
        ...(implicitCosts && showImplicitCost && { implicitCosts }),
        ...(flagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING) && {
            ...paramsForDms,
        }),
    };

    if (isHiringWithFunds) {
        const immAvailableAccountsWithFunds = getState().raGlobalPosition.get(
            'availableAccountsWithFunds',
        );
        const selectedAccountId = getState().raHireManagementPlan.getIn([
            'steps',
            '2',
            'selectedAccount',
        ]);
        const accountCC = immAvailableAccountsWithFunds.getIn([
            selectedAccountId,
            'accountNumber',
        ]);

        const mappedFunds = immHireManagementPlan
            .get('selectedAccountsWithFunds')
            .entrySeq()
            .reduce((acc, entry) => {
                const accountId = entry[0];
                const immFunds = entry[1];
                immFunds.forEach(fundId => {
                    const immFund = immAvailableAccountsWithFunds.getIn([
                        accountId,
                        'funds',
                        fundId,
                    ]);
                    acc.push({
                        accountcc: accountCC,
                        contract: immFund.get('contract'),
                        fundName: immFund.get('name'),
                        isin: immFund.get('isin'),
                        minimunUnits: immFund.get(
                            'customMinimumPurchaseAmount',
                        ),
                        decimals: immFund.get('customNumber1'),
                        nav: immFund.get('nav'),
                        navDate: immFund.get('navDate'),
                        units: immFund.get('shares'),
                    });
                });
                return acc;
            }, []);
        query.validFundsList = mappedFunds;
    }

    const requestData = {
        query: query,
    };

    const selectedStrategy = immSimulation.get('selectedPortfolio');
    const objectiveType = immSimulation.get('type');
    let objective;
    if (!!objectiveType) {
        objective = objectiveType;
    } else {
        objective = 'sin objetivo';
    }

    const customData = {
        processDetail: 'robo cartera ' + selectedStrategy + ' ' + objective,
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raCreateAccount'),
        requestData,
    )
        .then(() => {
            dispatch(createAccountSuccess());
            dispatch(deleteSimulation(simulationId, true));
            dispatch(outdateMyInvestments());

            recordProcess(PROC_RA_CONTRACTS, PROC_END, customData);
        })
        .catch(error => {
            dispatch(createAccountError(error, step));
            dispatch(raErrorHandlerActions.show(error, history));

            recordProcess(PROC_RA_CONTRACTS, PROC_FAIL, customData);
        });
};

const postEmailChange = (dataToken, includeObjective, history) => (
    dispatch,
    getState,
) => {
    const immStep = getState().raHireManagementPlan.getIn([
        'steps',
        FOURTH_STEP,
    ]);
    const requestData = {
        query: {
            tokenFirma: dataToken,
            email: immStep.get('email'),
        },
    };
    dispatch(requestCreateAccount());
    APIPost(dispatch, apiURLBuilder.getURL('userEmail'), requestData)
        .then(() => {
            dispatch(createAccount(dataToken, includeObjective, history));
        })
        .catch(() => {
            dispatch(emailConfigurationError());
        });
};

const enableDisclaimerCheck = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_ENABLE_DISCLAIMER_CHECK,
});

const finish = (history, includeObjective) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const emailConfigured = PersonalDataHelper.getEmail(immProfile);
    const customRequest = emailConfigured ? createAccount : postEmailChange;
    const callback = (dispatch, getState, dataToken) => {
        dispatch(customRequest(dataToken, includeObjective, history));
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const closeDistributionModal = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_CLOSE_DISTRIBUTION_MODAL,
});

const openDistributionModal = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_PLAN_OPEN_DISTRIBUTION_MODAL,
});

const getExplicitImplicitCostsSuccess = data => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_EXPLICIT_IMPLICIT_COST_RETRIEVED,
    payload: {
        data,
    },
});

const getExplicitImplicitCostsError = error => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_EXPLICIT_IMPLICIT_COST_ERROR,
    payload: {
        error,
    },
});

const getExplicitImplicitCosts = (productId, investmentAmount, history) => (
    dispatch,
    getState,
) => {
    const language = getFormattedLanguage();
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const requestData = {
        header: {
            'Accept-Language': language,
        },
        query: {
            initialLumpSum: investmentAmount,
        },
    };
    const params = {
        id: productId,
    };

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raServiceCost', params),
        requestData,
    )
        .then(response => {
            dispatch(getExplicitImplicitCostsSuccess(response));
            if (
                __CONTACT_CENTER__ &&
                immFlagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING)
            ) {
                dispatch(
                    dmsManagementPlanInit(history, response.implicitCosts),
                );
            }
        })
        .catch(response => {
            dispatch(getExplicitImplicitCostsError(response));
        });
};

const getHirePlanConfirmationPDFFetching = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_FETCHING,
});

const getHirePlanConfirmationPDFSuccess = data => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_SUCCESS,
    payload: data,
});

const getHirePlanConfirmationPDFFailure = () => ({
    type: actionTypes.RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_FAILURE,
});

const getHirePlanConfirmationPDF = () => (dispatch, getState) => {
    const immHireManagementPlan = getState().raHireManagementPlan;
    const immAccounts = getState().accounts;
    const immSimulation = getState().raSimulation;
    dispatch(getHirePlanConfirmationPDFFetching());
    const isHiringWithFunds =
        immHireManagementPlan.getIn(['steps', FIRST_STEP, 'investmentType']) ===
        RA_INVESTMENT_TYPE_FOUNDS;
    const investmentAmount = isHiringWithFunds
        ? 0
        : immHireManagementPlan.getIn([
              'steps',
              FIRST_STEP,
              'investmentAmount',
          ]);
    const accountId = immHireManagementPlan.getIn([
        'steps',
        THIRD_STEP,
        'selectedAccount',
    ]);

    const selectedAccountAlias = immAccounts.getIn([
        'byId',
        accountId,
        'description',
    ]);

    const selectedAccountContract = immAccounts.getIn([
        'byId',
        accountId,
        'oldFullContractNumber',
    ]);

    const account = `${selectedAccountAlias.trim()} ...${selectedAccountContract.slice(
        -4,
    )}`;

    const selectedPortfolioId = immSimulation.getIn([
        'simulation',
        'selectedPortfolio',
    ]);

    let periodicAmount, periodicDepositDay, periodicityType;
    if (
        !!immHireManagementPlan.getIn([
            'steps',
            SECOND_STEP,
            'recurringContributionAmount',
        ])
    ) {
        periodicAmount = immHireManagementPlan.getIn([
            'steps',
            SECOND_STEP,
            'recurringContributionAmount',
        ]);

        const periodicity = immHireManagementPlan.getIn([
            'steps',
            SECOND_STEP,
            'periodicity',
        ]);

        switch (periodicity) {
            case CONTRIBUTION_PERIOD_DAILY:
                periodicityType = 'D';
                periodicDepositDay = '';
                break;
            case CONTRIBUTION_PERIOD_WEEKLY:
                periodicityType = 'W';
                periodicDepositDay = '';
                break;
            case CONTRIBUTION_PERIOD_MONTHLY:
                periodicityType = 'M';
                periodicDepositDay = immHireManagementPlan.getIn([
                    'steps',
                    SECOND_STEP,
                    'contributionDay',
                ]);
                break;
            default:
                break;
        }
    }

    const requestData = {
        query: {
            account: account,
            channel: isPrintOfficeMode() ? 'OFI' : 'CC',
            initialAmount: investmentAmount,
            periodicAmount: periodicAmount,
            periodicDepositDay: periodicDepositDay,
            periodicity: periodicityType,
            promoter: '',
            investmentType: selectedPortfolioId,
        },
    };
    APIPost(dispatch, apiURLBuilder.getURL('raPdfHirePortfolio'), requestData)
        .then(response => dispatch(getHirePlanConfirmationPDFSuccess(response)))
        .catch(() => dispatch(getHirePlanConfirmationPDFFailure()));
};

module.exports = {
    changeTransferFundsAccount,
    changeInvestmentType,
    configureUserEmail,
    closeDistributionModal,
    deleteSimulation,
    enableDisclaimerCheck,
    finish,
    getPDFContract,
    openDistributionModal,
    reset,
    resetStep,
    restValueOfObjective,
    updateSelectedAccountsWithFunds,
    updateSelectedFundsTotal,
    setInvestmentAmount,
    setSelectedAccount,
    setVisibleStep,
    validateStep,
    toggleDisclaimer,
    getExplicitImplicitCosts,
    validateCalendarStep,
    setInitialContributionAmount,
    setRecurringContributionAmount,
    setPeriodicity,
    setContributionDay,
    getHirePlanConfirmationPDF,
    dmsManagementPlanInit,
    saveTermsAndConditions,
};
